import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useMemo,
  useState,
} from 'react';

type BarPosition = 'bottom' | 'side';

type CatchUpSearchContextType = {
  searchText: string;
  setSearchText: (value: string) => void;
  barPosition: BarPosition;
  setBarPosition: Dispatch<SetStateAction<BarPosition>>;
};

const CatchUpSearchContext = createContext<CatchUpSearchContextType>({
  searchText: '',
  setSearchText: () => void 0,
  barPosition: 'bottom',
  setBarPosition: () => void 0,
});

type CatchUpSearchContextProviderProps = {
  children: ReactNode;
};

export const CatchUpSearchContextProvider = ({
  children,
}: CatchUpSearchContextProviderProps) => {
  const [searchText, setSearchText] = useState('');
  const [barPosition, setBarPosition] = useState<BarPosition>('bottom');

  const value = useMemo(
    () => ({
      searchText,
      setSearchText,
      barPosition,
      setBarPosition,
    }),
    [searchText, barPosition]
  );

  return (
    <CatchUpSearchContext.Provider value={value}>
      {children}
    </CatchUpSearchContext.Provider>
  );
};

export const useCatchUpSearchContext = () => useContext(CatchUpSearchContext);
